import { createSlice } from "@reduxjs/toolkit";
import {
  SHIFT_TYPES,
  PROCEDURE_TYPES,
  ANESTESIA_TECHNIQUE,
} from "../../../secretary/data";

const initialState = {
  doctorsSelect: {
    data: [],
    isLoading: false,
    message: null,
  },
  shiftTypes: SHIFT_TYPES,
  procedureTypes: PROCEDURE_TYPES,
  anesthesiaTechniques: ANESTESIA_TECHNIQUE,
  message: null,
  isLoading: false,
  shiftProcedures: {
    data: [],
    isLoading: false,
    message: null,
  },
  params: {
    doctorId: "",
    patientDocument: "",
    procedureType: "",
    hasComplications: "",
    startProcedureTime: "",
    endProcedureTime: "",
  },
  pageSize: "5",
  page: "1",
  totalPages: 1,
};

const resetState = (state, keys) => {
  keys.forEach((key) => {
    state[key] = initialState[key];
  });
};

export const shiftProcedureSlice = createSlice({
  name: "shiftProcedure",
  initialState,
  reducers: {
    loadingDoctorsSelect: (state) => {
      state.doctorsSelect.isLoading = true;
      state.doctorsSelect.message = null;
    },
    loadedDoctorsSelect: (state, { payload }) => {
      state.doctorsSelect.data = payload.doctors;
      state.doctorsSelect.isLoading = false;
      state.doctorsSelect.message = {
        type: "success",
        text: payload.message,
      };
    },
    failedDoctorsSelect: (state, { payload }) => {
      state.doctorsSelect.isLoading = false;
      state.doctorsSelect.message = {
        type: "error",
        text: payload,
      };
    },
    loading: (state) => {
      state.isLoading = true;
      state.message = null;
    },
    loaded: (state) => {
      state.isLoading = false;
      state.message = null;
    },
    errorMessage: (state, { payload }) => {
      state.isLoading = false;
      state.message = {
        type: "error",
        text: payload,
      };
    },
    successMessage: (state, { payload }) => {
      state.isLoading = false;
      state.message = {
        type: "success",
        text: payload,
      };
    },
    loadingShiftProcedures: (state) => {
      state.shiftProcedures.isLoading = true;
      state.shiftProcedures.message = null;
      state.message = null;
    },
    loadedShiftProcedures: (state, { payload }) => {
      state.shiftProcedures.data = payload.shiftProcedures;
      state.shiftProcedures.isLoading = false;
      state.page = payload.page;
      state.totalPages = payload.totalPages;
      state.shiftProcedures.message = {
        type: "success",
        text: payload.message,
      };
    },
    failedShiftProcedures: (state, { payload }) => {
      state.shiftProcedures.isLoading = false;
      state.shiftProcedures.message = {
        type: "error",
        text: payload,
      };
    },
    addShiftProcedure: (state, { payload }) => {
      state.shiftProcedures.data.unshift(payload);
    },
    changeParams: (state, { payload }) => {
      state.params = payload;
    },
    resetParams: (state) => {
      resetState(state, ["params"]);
    },
    changePageSize: (state, { payload }) => {
      state.pageSize = payload;
    },
    changePage: (state, { payload }) => {
      state.page = payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  loadingDoctorsSelect,
  loadedDoctorsSelect,
  failedDoctorsSelect,
  loading,
  loaded,
  errorMessage,
  successMessage,
  loadingShiftProcedures,
  loadedShiftProcedures,
  failedShiftProcedures,
  addShiftProcedure,
  changeParams,
  resetParams,
  changePageSize,
  changePage,
} = shiftProcedureSlice.actions;
